import { UserModel } from "@/app/entities";
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

type AuthStoreType = {
  currentUser: UserModel | null;
  token: string | undefined;
  sessionToken: string | undefined;
  isAuthenticated: boolean;
  fetchingCurrentUser: boolean;
  profilePicture?: string;
  fullname: () => string;
  role: () => string;
  setProfilePicture: (profilePicture: string) => void;
  setCurrentUser: (currentUser: UserModel) => void;
  resetMe: (cb?: () => void) => void;
  setIsAuthenticated: (isAuthenticated: boolean) => void;
  setFetchingCurrentUser: (fetchingCurrentUser: boolean) => void;
};

export const useAuthStore = create<AuthStoreType>()(
  persist(
    (set, get) => {
      return {
        currentUser: null,
        token: undefined,
        sessionToken: undefined,
        isAuthenticated: false,
        fetchingCurrentUser: false,
        profilePicture: "",
        fullname: () => {
          return get().currentUser
            ? `${get().currentUser?.prenom ?? ""} ${
                get().currentUser?.nom ?? ""
              }`
            : "";
        },
        role: () => {
          return get().currentUser?.type ?? "";
        },
        setProfilePicture: (profilePicture: string) => set({ profilePicture }),
        setCurrentUser: (me: UserModel) => set({ currentUser: me }),
        resetMe: (cb: () => void = () => {}) => {
          set({
            currentUser: null,
            token: undefined,
            sessionToken: undefined,
            isAuthenticated: false,
          });

          cb();
        },
        setIsAuthenticated: (isAuthenticated: boolean) =>
          set({ isAuthenticated }),
        setFetchingCurrentUser: (fetchingCurrentUser: boolean) =>
          set({ fetchingCurrentUser }),

        clearStore: () => {
          set({
            currentUser: null,
            token: undefined,
            sessionToken: undefined,
            isAuthenticated: false,
            fetchingCurrentUser: false,
          });
          localStorage.removeItem("auth-storage");
        },
      };
    },
    {
      name: "auth-storage", // Unique name for the storage key
      storage: createJSONStorage(() => localStorage), // Use localStorage for persistence
      partialize: (state) => ({
        currentUser: state.currentUser,
        token: state.token,
        sessionToken: state.sessionToken,
        isAuthenticated: false,
      }), // Persist only specific parts of the state
    }
  )
);
